"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const qualifications = [{
  title: "Senior Coach",
  association: "DBVC / IOBC",
  description: "Zertifiziertes Mitglied im Deutschen Bundesverband Coaching e.V. und der International Organization for Business Coaching – der Goldstandard im Business Coaching."
}, {
  title: "Heilpraktikerin für Psychotherapie",
  association: "Main-Kinzig-Kreis (Hessen)",
  description: "Staatliche Erlaubnis zur Ausübung der Heilkunde beschränkt auf das Gebiet der Psychotherapie, verliehen in der Bundesrepublik Deutschland durch das Gesundheitsamt Main-Kinzig-Kreis, Hessen."
}, {
  title: "Trainerin Fachverband GFK®",
  association: "GFK",
  description: "Anerkannte Trainerin im Fachverband Gewaltfreie Kommunikation e.V. – Fokus auf empathische Klärung und Verbindung."
}, {
  title: "Mediatorin",
  association: "Mitglied im BM e.V.",
  description: "Mitglied im Bundesverband Mediation e.V. – Verpflichtung zu konstruktiven und konsensualen Wegen der Konfliktbeilegung."
}, {
  title: "Gross National Happiness Practitioner",
  association: "HS Osnabrück / ELI",
  description: "Zertifizierte Expertin für das Konzept des Bruttonationalglücks (Hochschule Osnabrück / Eurasia Learning Institute)."
}, {
  title: "Zertifizierte Stressmanagement- & Achtsamkeitstrainerin",
  association: "ZPP",
  description: "Anerkennung durch die Zentrale Prüfstelle Prävention (ZPP) für zertifizierte Kurse in Stressbewältigung und Achtsamkeit."
}, {
  title: "Lehrerin für Tai Ji • Qi Gong • Yoga",
  association: "ZPP, DDQT, Yoga Alliance",
  description: "Fachliche Zertifizierung durch die Yoga Alliance (RYT) und die H.N.B. Garhwal University (Indien) sowie ZPP-Anerkennung für Präventionskurse."
}];
export default function BeruflicheAngaben() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="berufliche-angaben" className="bg-accent py-20 md:py-32">
      <div className="container mx-auto px-4 max-w-3xl">
        <div ref={ref} className={`transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-4xl font-light text-foreground mb-16 text-center tracking-wider">
            Berufliche <span className="heading-italic">Qualifikationen</span>
          </h2>

          <div className="flex flex-col gap-10">
            {qualifications.map((item, i) => <div key={i} data-index={i} className="flex flex-col border-l-2 border-primary/20 pl-6 py-2">
                <h3 className="font-serif text-xl md:text-2xl font-light text-foreground tracking-wider">
                  {item.title}
                  <span className="heading-italic text-primary/70 text-lg md:text-xl"> ({item.association})</span>
                </h3>
                <p className="font-default text-foreground/80 font-light mt-2 leading-relaxed text-sm md:text-base">
                  {item.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}